import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import ErrorTexts from "./Translation/ErrorTexts";
import FormTexts from "./Translation/FormTexts";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: {}
    },
    lt: {
        translation: {
            "products": {
                "IL": "Vartojimo paskola",
                "IA": "Paskola automobiliui",
                "IR": "Paskola būsto remontui",
                "IS": "Paskola saulės elektrinėms",
                "IE": "IE", // todo: name (none exists atm)
                "IC": "Tikslinė paskola (energetika)",
                "": "",
            },
            "Welcome to React": "Sveiki atvyke i React and react-i18next",
            "step": {
                "registration": "Registracija",
                "proposal": "Pasiūlymas",
                "contract": "Sutartis",
                "error": "Klaida",
                "remote_sign_document": "Dokumento pasirašymas",
            },
            "substep": {
                "contacts": "Užpildykite savo duomenis",
                "incomes": "Pateikite informaciją įvertinimui atlikti",
                "income_family": "Jūsų šeimos bendros pajamos",
                "consents": "Susipažinkite su kliento anketa",
                "chooseSignMethod": "Pasirinkite jums patogiausią būdą pasirašyti kliento anketą",
                "chooseDocumentSignMethod": "Pasirinkite jums patogiausią būdą pasirašyti dokumentą",
                "documentPreview": "Susipažinkite su dokumento duomenimis",
                "aml": "Paskolos sutarčiai paruošti mums reikia",
                "view_contract": "Susipažinkite su paskolos sutartimi",
                "sign_contract": "Pasirinkite sutarties patvirtinimo-pasirašymo būdą",
                "send_spouse_link": "Sutuoktinio kontaktai"
            },
            // "forms": ,
            "deal_states": {
                'CA': 'Sutartis nutraukta nesulaukus akceptavimo',
                'CC': 'Sutartis nutraukta pagal atpirkimą',
                'CL': 'Sutartis anuliuota',
                'NA': 'Sudaryta, bet nepatvirtinta kompanijos',
                'NP': 'Nepatvirtinta ir neapmokėta',
                'OK': 'Sudaryta ir patvirtinta kompanijos',
                'PP': 'Apmokėta, bet neakceptuota',
                'RS': 'Restruktūrizuota sutartis',
                'VM': 'Bandomoji sutartis',
                'VO': 'Sutarties pavyzdys',
            },
            "registration_confirmation": "Registracijos patvirtinimas",
            "registration_confirmation_explanation": "Prašome palaukti, kol jūsų paskyra aktyvuojama. Į savitarną būsite nukreipti automatiškai.",
            "become_a_customer": "Tapkite klientu",
            "please_login": "Prisijunkite",
            "chosen_amount": "Preliminari paskolos suma",
            "chosen_type": "Pildoma paraiška",
            "chosen_term": "Preliminarus laikotarpis",
            "month": "mėn.",
            "coming_soon": "Netrukus",
            "read_sif": "Skaityti standartinę informaciją klientui",
            "view_schedule": "Peržiūrėti mokėjimo grafiką",
            "max_loan_amount": "Maksimali paskolos suma",
            "term": "Terminas",
            "your_prefered_sum": "Jūsų pasirinkta paskolos suma buvo <1></1> €",
            "representative_data": "Atstovo duomenys",
            "my_loans": "Mano paskolos",
            "there_is_button_at_the_bottom": "Norėdami tęsti, susipažinkite su informacija apie vartojimo kreditą. Jei pateikti duomenys yra teisingi,  spauskite mygtuką „Supratau,noriu sudaryti sutartį“, esantį puslapio apačioje",
            "initial_proposition": "Pasirinkta paskolos suma",
            "timeout": "Pasibaigė laikas, skirtas dokumento patvirtinimui. Bandykite dar kartą",
            "sif": {
                "header": "Standartinė informacija klientui",
            },
            "loans": "Paskolos",
            "change_contacts": "Keisti duomenis",
            "preview": "Peržiūrėti",
            "waiting_for_options": "Vyksta kreditingumo vertinimas",
            "waiting_for_eshop_data": "Palaukite, esate nukreipiami į Inbank paraiškos pildymo procesą",
            "will_chooce_different_amount": "Skolinsiuosi kitokią sumą",
            "financial_clauses": "Finansavimo sąlygos",
            "info_about_loan_is_being_prepared": "Ruošiama informacija apie vartojimo kreditą",
            "ondato_explanation_text": "Prieš pasirašydami sutartį pavedimu, patvirtinkite savo tapatybę padarydami asmens dokumento nuotrauką telefonu arba arba kompiuteriu.\n" +
                "Pasirinkus patvirtinimą telefonu, gausite SMS pranešimą su nuoroda procesui tęsti.\n" +
                "Kai asmens dokumentas bus patvirtintas kaip tinkamas, galėsite tęsti sutarties pasirašymą. ",
            "ondato_one_time_url_warning": "Nuorodą tapatybei patvirtinti galėsite atidaryti tik vieną kartą. Prieš atidarydami nuorodą, įsitikinkite, kad su savimi turite reikalingą asmens dokumentą (pasą, asmens tapatybės kortelę arba nuolatinį leidimą gyventi Lietuvoje). Norėdami pakartoti veiksmus dėl nepavykusio tapatybės patvirtinimo, neuždarykite šio lango, kol jis nepersikraus (tai gali užtrukti iki 10min). Persikrovus puslapiui pakartokite veiksmus.",
            "dear_customer": "Mielas kliente,",
            "choose_spouse_link_sending_method": "Pasirinkite, kokiu būdu Jūsų sutuoktiniui persiųsti nuorodą kliento anketai pasirašyti",
            "spouse_consent_not_signed_yet": "Jūsų sutuoktinis dar nepasirašė Kliento anketos. Prašome palaukti.",
            "currency" : " €",
        }
    }
};

/**
 * Merge separate translation files
 */
_.merge(resources, FormTexts);
_.merge(resources, ErrorTexts);

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "lt",
        // debug: true,

        // keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
